
const headers = (t: (key: string) => string) => [
    {
        label: t("schedule.type"),
        className: "w-30p"
    },
    {
        label: t("schedule.frequency"),
        className: "w-30p"
    },
    {
        label: t("schedule.status"),
        className: "w-5p"
    },
    {
        label: t("schedule.actions"),
        className: "w-5p"
    },
];

export const ScheduleConfig = {
    headers,
};
